import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { sideBar } from '../../core/constants/sidebar.const';
import { AuthService } from '../../services/auth.service';
import { assets } from '../../core/constants/assets.const';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LoginResponse } from '../../models/auth.model';
import { ModuleConst, userRole } from '../../core/constants/keys.constant';
import { SideBar } from '../../models/sideBar.model';

@Component({
  selector: 'mindbase-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit, OnDestroy {
  assetsConst = assets;
  public sideBar = sideBar;
  public innerWidth = 0;
  public sidenavWidth = 5;
  private destroy: Subject<boolean> = new Subject<boolean>();
  protected subscriptionSubject$!: Subscription;
  protected profile: LoginResponse | null = null;
  protected moduleConst = ModuleConst;
  constructor(public _authService: AuthService) {}

  ngOnInit(): void {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.profile = res;
          this.handleSideBar(res);
        }
      });
  }

  private handleSideBar(res: LoginResponse): void {
    if (res.role === userRole.SUBADMIN) {
      this.subAdminRoleHandler(res);
    } else {
      this.sideBar.forEach((el: SideBar) => {
        el.isView = el.isAdd = el.isEdit = el.isDelete = true;
      });
    }
  }
  private subAdminRoleHandler(res: LoginResponse): void {
    const removeableItems = new Set([this.moduleConst.SubAdmin]);

    // ✅ Use roleDetail.permission OR accessRole.permission
    const permissions = res?.roleDetail?.permission || res?.accessRole?.permission || [];

    this.sideBar = this.sideBar.filter(item => {
      if (removeableItems.has(item.sideBarId)) {
        return false;
      }

      const current = permissions.find(el => el.sideBarId === item.sideBarId);

      if (current) {
        Object.assign(item, {
          isView: current.isView,
          isAdd: current.isAdd,
          isEdit: current.isEdit,
          isDelete: current.isDelete
        });
      }

      return true;
    });
  }


  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }
  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1199.98) {
      this._authService.toggleSidebarView();
    }
  }
  toggleSidenavWeb(): void {
    this._authService.toggleSidebarView();
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
    this.subscriptionSubject$.unsubscribe();
  }
}
